import { useCallback, useEffect } from 'react';
import { replace } from 'connected-react-router';
import { useRouteMatch, generatePath } from 'react-router';
import { useDispatch, useSelector } from 'react-redux';
import {
  setCurrentOrganizationTab, setCurrentOwnOrganizationTab,
  setCurrentProfileTab,
  setCurrentProjectTab, setCurrentUserTab, setCurrentVideoMenuTab,
} from '../../store/modules/tabs/actions';
import {
  selectCurrentOrganizationTab,
  selectCurrentOwnOrganizationTab,
  selectCurrentProfileTab,
  selectCurrentProjectTab, selectCurrentUserTab,
  selectCurrentVideoMenuTab,
} from '../../store/modules/tabs/selectors';

const TabRedirect = () => {
  const { path, params } = useRouteMatch();
  const dispatch = useDispatch();

  const currentProjectTab = useSelector(selectCurrentProjectTab);
  const currentOrganizationTab = useSelector(selectCurrentOrganizationTab);
  const currentProfileTab = useSelector(selectCurrentProfileTab);
  const currentOwnOrganizationTab = useSelector(selectCurrentOwnOrganizationTab);
  const currentVideoMenuTab = useSelector(selectCurrentVideoMenuTab);
  const currentUserTab = useSelector(selectCurrentUserTab);

  const saveProjectTab = useCallback(() => {
    const paths = [
      '/dashboard/projects/:id/overview',
      '/dashboard/projects/:id/media',
      '/dashboard/projects/:id/scripts',
      '/dashboard/projects/:id/activity',
      '/dashboard/projects/:id/admin',
    ];

    if (paths.includes(path)) {
      dispatch(setCurrentProjectTab(path));
    }
  }, [path, dispatch]);

  const saveOrganizationTab = useCallback(() => {
    const paths = [
      '/dashboard/admin/organizations/:id/account',
      '/dashboard/admin/organizations/:id/team',
      '/dashboard/admin/organizations/:id/billing',
    ];

    if (paths.includes(path)) {
      dispatch(setCurrentOrganizationTab(path));
    }
  }, [path, dispatch]);

  const saveOwnOrganizationTab = useCallback(() => {
    const paths = [
      '/dashboard/user/organizations/:id/account',
      '/dashboard/user/organizations/:id/team',
      '/dashboard/user/organizations/:id/billing',
    ];

    if (paths.includes(path)) {
      dispatch(setCurrentOwnOrganizationTab(path));
    }
  }, [path, dispatch]);

  const saveVideoMenuTab = useCallback(() => {
    const paths = [
      '/dashboard/admin/video-menus/:id/info',
      '/dashboard/admin/video-menus/:id/videos',
      '/dashboard/admin/video-menus/:id/menus',
      '/dashboard/admin/video-menus/:id/presentation',
      '/dashboard/admin/video-menus/:id/options',
      '/dashboard/admin/video-menus/:id/format',
      '/dashboard/admin/video-menus/:id/social-media',
    ];

    if (paths.includes(path)) {
      dispatch(setCurrentVideoMenuTab(path));
    }
  }, [path, dispatch]);

  const saveProfileTab = useCallback(() => {
    const paths = [
      '/dashboard/profile/me',
      '/dashboard/profile/billing/plan',
    ];

    if (paths.includes(path)) {
      dispatch(setCurrentProfileTab(path));
    }
  }, [path, dispatch]);

  const saveUserTab = useCallback(() => {
    const paths = [
      '/dashboard/admin/users/:id/profile',
      '/dashboard/admin/users/:id/billing/plan',
    ];

    if (paths.includes(path)) {
      dispatch(setCurrentUserTab(path));
    }
  }, [path, dispatch]);

  // redirect to tab
  useEffect(() => {
    if (path === '/dashboard/projects/:id') {
      const redirectPath = generatePath(currentProjectTab, params);
      dispatch(replace(redirectPath));
    }

    if (path === '/dashboard/admin/organizations/:id') {
      const redirectPath = generatePath(currentOrganizationTab, params);
      dispatch(replace(redirectPath));
    }

    if (path === '/dashboard/user/organizations/:id') {
      const redirectPath = generatePath(currentOwnOrganizationTab, params);
      dispatch(replace(redirectPath));
    }

    if (path === '/dashboard/profile') {
      const redirectPath = generatePath(currentProfileTab, params);
      dispatch(replace(redirectPath));
    }

    if (path === '/dashboard/admin/video-menus/:id') {
      const redirectPath = generatePath(currentVideoMenuTab, params);
      dispatch(replace(redirectPath));
    }

    if (path === '/dashboard/admin/users/:id') {
      const redirectPath = generatePath(currentUserTab, params);
      dispatch(replace(redirectPath));
    }
  }, [
    path,
    params,
    dispatch,
    currentProjectTab,
    currentOrganizationTab,
    currentProfileTab,
    currentOwnOrganizationTab,
    currentVideoMenuTab,
    currentUserTab,
  ]);

  // save tab
  useEffect(() => {
    saveProjectTab();
    saveOrganizationTab();
    saveProfileTab();
    saveOwnOrganizationTab();
    saveVideoMenuTab();
    saveUserTab();
  }, [
    path,
    dispatch,
    saveProfileTab,
    saveProjectTab,
    saveOrganizationTab,
    saveOwnOrganizationTab,
    saveVideoMenuTab,
    saveUserTab,
  ]);

  return null;
};

export default TabRedirect;
